import React from 'react';

import '../style.css';
import CONF from '../Conf';

import AnnouncementCard from '../Cards/Announcement';
import BlogCard from '../Cards/Blog';
import FavoriteCard from '../Cards/Favorite';
import MessageCard from '../Cards/Message';
import SolutionCard from '../Cards/Solution';
import DailyAverageCard from '../Cards/DailyAverage';
import MetricPredictionsCard from '../Cards/MetricPredictions';
import WeeklySummaryCard from '../Cards/WeeklySummary';
import LoadingCard from '../Cards/Loading';
import ErrorCard from '../Cards/Error';

// import moment from 'moment'
import { Waypoint } from 'react-waypoint';

function shuffle(a) {
  var j, x, i;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
  return a;
}

export default class CardList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cards: [],
      conditions: {
        pending: 1,
        loading: 2,
        loaded: 3,
        error: 4,
      },
      condition: 1,
      errors: [],
    };
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.state.condition === this.state.conditions['pending']) {
        this.loadInitialItems();
      }
      setInterval(() => {
        if (this.state.condition === this.state.conditions['pending']) {
          this.loadMoreItems();
        }
      }, 100);
    }, 50);
  }

  loadItemsFromQuery(query) {
    let { at, deviceType, deviceUuid, language } = this.props;
    if (this.state.condition === this.state.conditions['loading']) {
      console.log('return from loading');
      return;
    }
    this.setState((state) => {
      return {
        condition: state.conditions['loading'],
      };
    });
    this.props.graphqlClient
      .query({
        query: query,
        queryDeduplication: false,
        variables: { at, deviceUuid, deviceType, language },
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      })
      .then(({ loading, errors, data, networkStatus, partial }) => {
        this.setState((state) => {
          if (loading) {
            console.log('isloading');
            return {
              condition: state.conditions['loading'],
            };
          } else if (errors) {
            return {
              condition: state.conditions['error'],
              errors: errors,
            };
          } else {
            const newCards = []
              .concat(
                data.announcementTipForAllDeviceTypes,
                data.announcementTipForDeviceType,
                data.tempSolutionTip0,
                data.tempSolutionTip1,
                data.humidSolutionTip0,
                data.humidSolutionTip1,
                data.co2SolutionTip0,
                data.co2SolutionTip1,
                data.vocSolutionTip0,
                data.vocSolutionTip1,
                data.dustSolutionTip0,
                data.dustSolutionTip1,
                data.blogTip,
                data.humidFavoriteTip,
                data.vocFavoriteTip,
                data.pm25FavoriteTip,
                //data.productTip,
                //data.partnerTip,
                data.dailyScoreComparison,
                data.dailyTempComparison,
                data.dailyHumidComparison,
                data.dailyCo2Comparison,
                data.dailyVocComparison,
                data.dailyDustComparison,
                data.messageTip,
                data.tempPrediction,
                data.humidPrediction,
                data.co2Prediction,
                data.vocPrediction,
                data.dustPrediction,
                data.weeklySummaryTip
              )
              .filter((i) => i != null);
            return {
              condition: state.conditions['loaded'],
              cards: state.cards.concat(shuffle(newCards)),
            };
          }
        });
      });
  }

  loadInitialItems() {
    console.log('loadInitialItemsFromQuery');
    this.loadItemsFromQuery(CONF.service.insights.queries.insights.all);
  }

  loadMoreItems() {
    console.log('loadMoreItems');
    this.loadItemsFromQuery(CONF.service.insights.queries.insights.legacy);
  }

  renderLoadingCard() {
    return this.state.condition !== this.state.conditions.error ? <LoadingCard /> : null;
  }

  renderWaypoint() {
    return this.state.condition === this.state.conditions.loaded ? (
      <Waypoint
        onEnter={() => {
          // this.setState((state) => {
          this.loadMoreItems();
          //   return {
          //     condition: state.conditions.pending,
          //   };
          // });
        }}
      />
    ) : null;
  }

  renderError() {
    return this.state.condition === this.state.conditions.error ? <ErrorCard errors={this.state.errors} /> : null;
  }

  renderCards() {
    return this.state.cards
      .map(function (card) {
        switch (card.__typename) {
          case 'AnnouncementForAllDeviceTypesTip':
            return <AnnouncementCard {...card} />;
          case 'AnnouncementForDeviceTypeTip':
            return <AnnouncementCard {...card} />;
          case 'BlogTip':
            return <BlogCard {...card} />;
          case 'FavoriteTip':
            return <FavoriteCard {...card} />;
          case 'MessageTip':
            return <MessageCard {...card} />;
          case 'SolutionTip':
            return <SolutionCard {...card} />;
          case 'MetricPredictionsTip':
            return <MetricPredictionsCard {...card} />;
          case 'DailyAverageTip':
            return <DailyAverageCard {...card} />;
          case 'WeeklySummaryTip':
            return <WeeklySummaryCard {...card} />;
          default: {
            console.error('Unexpected Card Format', card);
            return null;
          }
        }
      })
      .filter((i) => i != null)
      .map((i, index) => <li key={`card ${index}`}>{i}</li>);
  }

  render() {
    return (
      <div>
        <ul className='Cards'>
          <li key={'error card'}>{this.renderError()}</li>
          {this.renderCards()}
          <li key={'loading card'}>{this.renderLoadingCard()}</li>
        </ul>
        {this.renderWaypoint()}
      </div>
    );
  }
}
